interface LoaderProps {
  size: "small" | "medium" | "big";
}

const Loader = ({ size }: LoaderProps) => (
  <img className={`spinner ${size}`} src="./Feedsmart_Symbol_Ring.svg" alt="loading-icon" />
);
export default Loader;
